/**
 * Build the canonical pathname for SEO redirects.
 * Default: no trailing slash (matches existing app links/routes).
 * Opt-in: meta.trailingSlash keeps a trailing slash (e.g. /app/).
 *
 * @param {string} path pathname only (no query)
 * @param {{ trailingSlash?: boolean }} [meta]
 * @returns {string}
 */
const canonicalizePath = (path, meta = {}) => {
  let canonical = path.toLowerCase();

  if (canonical.includes('.html')) {
    canonical = canonical.replace('.html', '');
  }

  if (meta?.trailingSlash) {
    if (canonical.slice(-1) !== '/') {
      canonical = `${canonical}/`;
    }
  } else if (canonical.length > 1 && canonical.endsWith('/')) {
    canonical = canonical.slice(0, -1);
  }

  return canonical;
};

export default canonicalizePath;
